const dataLayer = () => (typeof window !== 'undefined' ? window?.dataLayer : []);

export const pushToDataLayer = (trackingData: Record<string, any>) => {
  if ('ecommerce' in trackingData) {
    dataLayer()?.push({ ecommerce: null });
  }
  dataLayer()?.push(trackingData);
};
